import { render, staticRenderFns } from "./Loader.vue?vue&type=template&id=554ab2c4&scoped=true"
import script from "./Loader.vue?vue&type=script&lang=js"
export * from "./Loader.vue?vue&type=script&lang=js"
import style0 from "./Loader.vue?vue&type=style&index=0&id=554ab2c4&prod&style=scss&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "554ab2c4",
  null
  
)

export default component.exports